<div class="regional-details-view-container" *ngIf="regionalObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).user.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100"  fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię" [value]="regionalObject.firstName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Nazwisko" [value]="regionalObject.lastName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div [fxFlex]="!(userPermissions | async).user.admin_root ? '100' : '50'">
                <app-detail header="Email" [value]="regionalObject.email"></app-detail>
              </div>
              <div [fxFlex]="!(userPermissions | async).user.admin_root ? '100' : '50'">
                <app-detail *ngIf="regionalObject.phone" header="Numer telefonu" [value]="(regionalObject.phone | phone)"></app-detail>
                <app-detail *ngIf="!regionalObject.phone" header="Numer telefonu" [value]=" ' ' "></app-detail>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Użytkownik">
                  {{regionalObject?.accountUser?.firstName}} {{regionalObject?.accountUser?.lastName}}
                </app-detail>
              </div>
              <div *ngIf="(userPermissions | async).user.admin_root" fxFlex="50">
                <app-detail  header="Hasło" [value]="regionalObject.password"></app-detail>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="30px">
              <div fxFlex="100">
                <app-detail-bool header="Aktywny" [value]="!regionalObject.deleted"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
  </div>
</div>
